import request from '@/utils/request'

/**
 * @param {import('@/types/generated/openapi').paths['/user/message']['get']['parameters']['query']} params
 */
export function getMessageList(params) {
  return request({
    url: 'user/message',
    method: 'get',
    params
  })
}

/**
 * 【我的消息】提交异步导出任务
 */
export function submitUserMessageExportAsyncTask(params) {
  return request({
    url: 'user/message/export-async',
    method: 'post',
    params
  })
}

export function getMessageDetail(id) {
  return request({
    url: 'user/message/' + id,
    method: 'get'
  })
}

export function updateMessage(id, data) {
  return request({
    url: 'user/message/' + id,
    method: 'put',
    data
  })
}

/** 用户获取消息统计 */
export function getMessageStatics(params) {
  return request({
    url: `/user/message/statics`,
    method: 'get',
    params: params
  })
}
